/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Format_P3Inputs */

const en_wc_tut_format_p3 = /** @type {(inputs: Wc_Tut_Format_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type * or 1. followed by a space to start a list. Enter continues the list, Tab demotes an item and Shift+Tab promotes it.`)
};

/**
* | output |
* | --- |
* | "Type * or 1. followed by a space to start a list. Enter continues the list, Tab demotes an item and Shift+Tab promotes it." |
*
* @param {Wc_Tut_Format_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_format_p3 = /** @type {((inputs?: Wc_Tut_Format_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Format_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_format_p3(inputs)
});
export { wc_tut_format_p3 as "wc.tut.format.p3" }